import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ScrollTop } from 'primereact/scrolltop';
import { TabPanel, TabView } from 'primereact/tabview';
import { RevisePubProjectProposalDetail } from 'features/RevisePubProjectProposal/pages';

import Layout from 'layout';
import { LayoutProvider } from 'layout/context/layoutcontext';

import { AbilityContext } from 'components/Can';

function RevisePubProjectProposalDetailPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const ability = useContext(AbilityContext);
  const [searchParams] = useSearchParams();
  const tab = searchParams.get('tab') || 0;

  return (
    <LayoutProvider>
      <Layout
        style={{
          maxHeight: 'calc(100vh - 9rem)',
          overflowY: 'auto',
          borderRadius: '12px',
          border: '1px solid var(--surface-border)',
          backgroundColor: 'white',
        }}
      >
        <>
          <TabView
            activeIndex={parseInt(tab, 10)}
            onTabChange={(e) => navigate(`.?tab=${e.index}`)}
          >
            {ability.can('read', 'pub_project_proposal') ? (
              <TabPanel
                header={t('projectProposal.viewDetail.labelTab0')}
                leftIcon="pi pi-file mr-2"
              >
                <RevisePubProjectProposalDetail />
              </TabPanel>
            ) : (
              <h4 className="text-red-500">{t('permission.forbid.read.projectProposalList')}</h4>
            )}

            {/* {ability.can('read_prequalification', 'council') && (
              <TabPanel
                header={t('projectProposal.viewDetail.labelTab1')}
                leftIcon="pi pi-list mr-2"
              >
                <PrequalificationCouncil />
              </TabPanel>
            )}
            {ability.can('read', 'council') && (
              <TabPanel
                header={t('projectProposal.viewDetail.labelTab2')}
                leftIcon="pi pi-list mr-2"
              >
                <SpecializationCouncil />
              </TabPanel>
            )}
            {ability.can('read', 'council') && (
              <TabPanel
                header={t('projectProposal.viewDetail.labelTab3')}
                leftIcon="pi pi-list mr-2"
              >
                <FinanceCouncil />
              </TabPanel>
            )} */}
          </TabView>
          <ScrollTop target="parent" />
        </>
      </Layout>
    </LayoutProvider>
  );
}

export default RevisePubProjectProposalDetailPage;
